/**
 * @deprecated 사이트 메타는 siteSeo.js를 사용하세요. 하위 호환 re-export.
 */
export {
    SITE_BROWSER_TITLE_TAGLINE,
    HOME_BROWSER_TITLE,
    pageBrowserTitle,
} from './siteSeo'
